export const activatedJson = [{label: 'فعال', value: true}, {label: 'غیر فعال', value: false}]

export const allowLoadJson = [{label: 'بارگیری شود', value: true}, {label: 'بارگیری نشود', value: false}]
export const oldestArray = [{label: 'قدیمی ترین', value: true}, {label: 'همه', value: false}]